// CORE
import React, { useEffect, useRef, useState } from "react";

// THIRD-PARTY LIBRARIES
import { useDispatch, useSelector } from "react-redux";
import { FormattedMessage } from "react-intl";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";

// REDUX
import { getCurrentUser } from "store/actions";

// HELPERS
import { handleImage } from "helpers/functions";

// ASSETS (SVGs)
import { ReactComponent as LogoutIcon } from "./assets/svg/logout.svg";
import { ReactComponent as UserIcon } from "./assets/svg/user.svg";
import { ReactComponent as ArrowDownIcon } from "./assets/svg/arrow-down.svg";

// ASSETS (IMAGES)
import userimg from "./assets/images/user.png";

const UserControl = () => {
    const { user } = useSelector((state) => state.authentication);
    const [userControlOpen, setUserControlOpen] = useState(false);
    const userDropdownRef = useRef(null);

    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getCurrentUser());
    }, [dispatch]);

    const toggleUserDropdown = () => setUserControlOpen(!userControlOpen);
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                userDropdownRef.current &&
                !userDropdownRef.current.contains(event.target)
            ) {
                setUserControlOpen(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);
    const defaultUserImg = userimg;
    const imageSrc = user?.image || defaultUserImg;

    const handleImageError = (event) => {
        event.currentTarget.src = defaultUserImg;
    };
    return (
        <div className="dropdown-container" ref={userDropdownRef}>
            <div className="dropdown-toggler" onClick={toggleUserDropdown}>
                <div className="user-image">
                    <img
                        src={handleImage(imageSrc)}
                        alt="User Image"
                        onError={handleImageError}
                    />
                </div>
                <div className="user-info">
                    <span className="name">
                        {user?.firstName || user?.name || (
                            <FormattedMessage id={"manager"} />
                        )}
                    </span>
                    <span className="role">
                        {user?.role?.name || <FormattedMessage id="manager" />}
                    </span>
                </div>
                <div className="dropdown-icon">
                    <ArrowDownIcon />
                </div>
            </div>

            <div
                className={`dropdown-menu ${
                    userControlOpen ? "fade-in" : "fade-out"
                }`}
            >
                <div className="dropdown-content">
                    <Link to={`/profile`}>
                        <Dropdown.Item className="profile" as={"span"}>
                            <UserIcon />
                            <FormattedMessage id="profile" />
                        </Dropdown.Item>
                    </Link>
                    <Link to={`/logout`}>
                        <Dropdown.Item as={"span"} className="logout">
                            <LogoutIcon />
                            <FormattedMessage id={"logout"} />
                        </Dropdown.Item>
                    </Link>
                </div>
            </div>
        </div>
    );
};

export default UserControl;
